import Preloader from "components/Common/Loader"
import PermissionsComponents from "components/Permission"
import UserForm from "components/User/form"
import React, { useEffect, useLayoutEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { getAllUserRegistrationData } from "store/general-renders/general-action"
import { generalAction } from "store/general-renders/general-slice"
import { regDataSelector } from "store/selectors"
import {
  getByIdUser,
  updateDirectPermission,
  updateUser,
} from "store/user/user-action"
import { userAction } from "store/user/user-slice"
import { getAllPermissionsGrouped } from "store/role/role-action"
import { isObject } from "lodash"

const EditUser = () => {
  document.title = "Edit User"
  const { id } = useParams()
  const navigate = useNavigate()
  const [loaded, setLoaded] = useState(false)
  const { regData, regLoading, regError } = useSelector(regDataSelector)

  const { loading, error, user } = useSelector(state => state.user)
  const permissionResponse = useSelector(state => state.user.permissionChange)
  const { groupedPermissions } = useSelector(state => state.role)

  const dispatch = useDispatch()

  /*
    handleSubmit

  - onSubmit: Triggered when the form is submitted for updating the User
  - values: Contains the form input values
  - Assigns the current 'id' to values
  - Dispatches the updateUser action with the ID, updated values, and navigation callback
*/
  const handleSubmit = values => {
    values.providers = values.providers.map(pr => (pr.value ? pr.value : pr))
    values.warehouses = values.warehouses.map(wr => (wr.value ? wr.value : wr))
    values.projects = values.projects.map(pr => (pr.value ? pr.value : pr))
    values.provinces = values.provinces.map(province =>
      isObject(province) ? province.value : province
    )
    values.ips = values.ips.map(ip => (ip.value ? ip.value : ip))
    values.item_categories = values.item_categories.map(category =>
      category.value ? category.value : category
    )
    values.commodity_classifications = values.commodity_classifications.map(
      classification =>
        classification.value ? classification.value : classification
    )
    values.id = id
    values.old_password = user?.old_password
    dispatch(updateUser(id, values, navigate))
  }

  // Dispatches the updateDirectPermission action with the ID, updated permission based status
  const onChangePermission = (permission, status) => {
    dispatch(updateDirectPermission(id, permission, status))
  }

  //   useLayoutEffect(() => {
  //     dispatch(userAction.resetState())
  //     dispatch(generalAction.resetUserRegData())
  //   }, [])

  // Get user by id and get all needed registration data
  useEffect(() => {
    dispatch(getAllUserRegistrationData())
    dispatch(getByIdUser(id))
    dispatch(getAllPermissionsGrouped())
    setLoaded(true)

    return () => {
      dispatch(userAction.resetState())
      dispatch(generalAction.resetUserRegData())
    }
  }, [dispatch])

  return (
    <React.Fragment>
      {regData?.data && user ? (
        <>
          <UserForm
            onSubmit={handleSubmit}
            loading={loading}
            error={error}
            user={user}
            formMode={"Edit"}
            regData={regData}
            regLoading={regLoading}
            regError={regError}
            permissions={regData?.data?.permissions}
            userDirectPermissions={user?.directPermissions}
            onChangePermission={onChangePermission}
            permissionResponse={permissionResponse}
            activePermissions={user?.activePermissions}
            groupedPermissions={groupedPermissions}
          />
        </>
      ) : (
        <Preloader loading={true} />
      )}
    </React.Fragment>
  )
}

export default EditUser
